import styled from 'styled-components';
import { TextStyle } from 'components/text';

export const Main = styled.div`
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1;
`;

export const Content = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  right: 25px;
  bottom: 25px;
  padding: 20px 0;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.neutral_200};
  box-shadow: 0px 2px 4px ${({ theme }) => theme.neutral_300};
`;

export const Anchor = styled.a`
  display: flex;
  text-decoration: none;
`;

export const Option = styled.button`
  display: flex;
  align-items: center;
  flex: 1;
  padding: 8px 20px;
  background-color: ${({ theme }) => theme.neutral_200};
  color: ${({ theme }) => theme.neutral_500};
  gap: 6px;
  cursor: pointer;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  ${TextStyle} {
    white-space: nowrap;
  }

  &:hover {
    background-color: ${({ theme }) => theme.neutral_700};
    color: ${({ theme }) => theme.neutral_100};
  }
`;

export const ToggleButton = styled.button`
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  background-color: ${({ theme }) => theme.neutral_700};
  color: ${({ theme }) => theme.neutral_100};
  box-shadow: 0px 2px 4px ${({ theme }) => theme.neutral_300};
  z-index: 2;
  cursor: pointer;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
`;
